import React,{useState} from 'react';
import {Link} from 'react-router-dom'
import Grid from '@mui/material/Grid';
//import Paper from '@mui/material/Paper';
//import Container from '@mui/material/Container';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
//import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Collapse from '@mui/material/Collapse';

//import PersonIcon from '@mui/icons-material/Person';
//import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
//import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import FaceIcon from '@mui/icons-material/Face';
import DownloadIcon from '@mui/icons-material/GetApp';
//import CreditScoreIcon from '@mui/icons-material/CreditScore';
//import ReceiptIcon from '@mui/icons-material/Receipt';
//import PublicIcon from '@mui/icons-material/Public';
//import RuleIcon from '@mui/icons-material/Rule';
import SecurityIcon from '@mui/icons-material/Security';
import Paper from '@mui/material/Paper';
import Title from './Title';
import useStyles from './Styles';
import {HelpDict,HelpData,HelpGroupName,HelpGroupStory,HelpGroupIcon} from './GuideDict';
//import Ajax from './Ajax';

//import PageTitle from './PageTitle';
//import {useStyles} from './useStyles';

interface GuideProps {
    dict: HelpDict
}

const GuideIndex:React.FC<GuideProps> = (guideProps)=> {
	const classes = useStyles();

	const IndexListItem = (props: {group: string})=>{
		const title = HelpGroupName[props.group];
		const story = HelpGroupStory[props.group];
		const icon = HelpGroupIcon[props.group];
		const [open, setOpen] = useState(false);
		const toggle = ()=>{
			setOpen(!open);
		}
		return (
		<React.Fragment>
			<ListItem button style={{paddingLeft:'0'}} onClick={toggle}>
				<ListItemIcon style={{marginRight:'0'}}><Avatar>{icon}</Avatar></ListItemIcon>
				<ListItemText primary={title} secondary={story} classes={{primary:classes.helpListPrimary,secondary:classes.helpListSecondary}}/>
			</ListItem>
			<Collapse in={open} timeout="auto" unmountOnExit>
				{guideProps.dict[props.group] &&
				<List dense style={{marginBottom:'2em'}}>
				{guideProps.dict[props.group].map((data:HelpData,index:number)=>{
					const key="group"+index;
					const to = "/help/"+props.group+"/"+data.id;
					return (
						<Link to={to} className={classes.HelpIndex} key={key}><ListItem>
							{data.title}
						</ListItem></Link>
					)
				})}
				</List>
				}
			</Collapse>						
		</React.Fragment>
		);
	};

	return (
        <div id="guide" className={classes.root+" "+classes.policy}>
            <Paper className={classes.paper}>
                <Title text="ヘルプ！" icon="store"/>
				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						<List>
							<IndexListItem group="owner"/>
							<IndexListItem group="item"/>
							<IndexListItem group="consign"/>
							<IndexListItem group="sale"/>
							<IndexListItem group="fee"/>
						</List>
					</Grid>
					<Grid item xs={12} md={6}>
						<List>
							<IndexListItem group="lottery"/>
							<IndexListItem group="prior"/>
							<IndexListItem group="secret"/>
							<IndexListItem group="book"/>
							<IndexListItem group="bye"/>
						</List>
					</Grid>
				</Grid>
				<Divider style={{marginTop:'1em',marginBottom:'1em'}}/>
				<List>
					<Link to="/term" className={classes.linkText}>
						<ListItem style={{paddingLeft:'0.5em'}}>
							<ListItemIcon style={{marginRight:'-1.0em'}}><FaceIcon/></ListItemIcon>
							<ListItemText primary="SideB利用規約" classes={{primary:classes.helpListPrimaryOnly}}/>
						</ListItem>
					</Link>
					<Link to="/privacy" className={classes.linkText}>
						<ListItem style={{paddingLeft:'0.5em'}}>
							<ListItemIcon style={{marginRight:'-1.0em'}}><SecurityIcon/></ListItemIcon>
							<ListItemText primary="個人情報保護方針" classes={{primary:classes.helpListPrimaryOnly}}/>
						</ListItem>
					</Link>
					<Link to="/law" className={classes.linkText}>
						<ListItem style={{paddingLeft:'0.5em'}}>
							<ListItemIcon style={{marginRight:'-1.0em'}}><SecurityIcon/></ListItemIcon>
							<ListItemText primary="特定商取引に関する法律に基づく表示" classes={{primary:classes.helpListPrimaryOnly}}/>
						</ListItem>
					</Link>
					<Link to="/logodownload" className={classes.linkText}>
						<ListItem style={{paddingLeft:'0.5em'}}>
							<ListItemIcon style={{marginRight:'-1.0em'}}><DownloadIcon/></ListItemIcon>
							<ListItemText primary="架空ストアのロゴ" classes={{primary:classes.helpListPrimaryOnly}}/>
						</ListItem>
					</Link>
				</List>
			</Paper>
		</div>
	)
}

export default GuideIndex;